



































import { Component, Prop, Vue, Inject } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import ID from "@abaco/web-components/src/ID";
import { HighlightOption } from "@abaco/web-components/src/components/directives/Highlight";

@Component({
    name: "TileButton",
    components: {
        BPopover
    },
    // needed for blur to actually works when enableMenu opened
    directives: {
        focus: {
            inserted: function(el, binding) {
                if (binding.value) {
                    el.focus();
                }
            }
        }
    }
})
export default class TileButton extends Vue {
    @Prop() public tooltip!: string;
    @Prop({ type: Boolean }) hasSideCard!: boolean;
    @Prop({ type: Boolean }) isActive!: boolean;
    @Prop() highlightOption!: HighlightOption;
    @Prop({ type: Boolean }) isContent!: boolean;
    @Prop() value!: boolean;
    @Prop({ type: Boolean }) isDisabled!: boolean;
    @Prop() customSideCardPopoverClass!: string;
    @Prop() boundary!: string;

    @Inject("isMenuEnabled") isMenuEnabled!: () => boolean;

    private id = ID.next();

    get showSideCard(): boolean {
        return this.value;
    }

    set showSideCard(val: boolean) {
        this.$emit("input", val);
    }

    onClick() {
        if (!this.isDisabled) {
            this.$emit("click");
        }
    }

    private get tileButtonClass() {
        return {
            active: this.isActive,
            toggled: this.showSideCard,
            hasSideCard: this.hasSideCard,
            content: this.isContent,
            "frk-tile-button-disabled cursor-not-allowed": this.isDisabled
        };
    }
}
